import { getFreshRecipeFormat } from '../../mealPlans';

export const getShortageText = recipe =>
  `Our ${getFreshRecipeFormat(
    recipe,
    true,
  )} is temporarily out of stock due to an inventory shortage. We're working like dogs to get this recipe back on the menu and appreciate your patience and understanding.`;
